import { RouteConfig } from 'vue-router';
import PublicoParecerReferencial from '../PublicoParecerReferencial.vue';

const baseRouterLink = '/parecer-referencial';

const PublicoParecerReferencialRoutes: RouteConfig[] = [
  {
    path: `${baseRouterLink}/consulta`,
    name: 'publico-consulta-pareceres-referenciais',
    component: PublicoParecerReferencial,
  },
];

export default PublicoParecerReferencialRoutes;
